import { searchTickets } from '@jq4race/api-client';
import { useQuery } from '@tanstack/react-query';

export const SEARCH_TICKETS_KEY = (q: string) => ['search-tickets', q] as const;

export function useSearchTickets(q: string) {
  return useQuery({
    queryKey: SEARCH_TICKETS_KEY(q),
    queryFn: () => searchTickets(q),
    enabled: q.trim().length > 0,
  });
}
